export const prepareGalleryObject = (images, youtubeVideo) => {
  const reshapedImages = images.map((image) => ({
    urls: { large: image.large_url },
  }));
  const reshapedArray = youtubeVideo === '' || youtubeVideo === null
    ? [...reshapedImages]
    : [{ youtube_id: youtubeVideo }, ...reshapedImages];
  return reshapedArray;
};
